import { createApp } from 'vue';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue';
import router from './router/index';
import store from './store/index';

// 创建应用实例
const app = createApp(App);

// 注册ElementPlus
app.use(ElementPlus);

// 注册路由和store
app.use(router);
app.use(store);

// 挂载应用
app.mount('#app'); 